const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]',
].join(',');

const ORIGINAL_ATTR = 'data-focus-guard-original';

const applyTabindex = (root, isOpen) => {
  const focusables = root.querySelectorAll(FOCUSABLE_SELECTOR);
  focusables.forEach((el) => {
    if (el.hasAttribute('data-focus-guard-skip')) return;

    if (isOpen) {
      if (!el.hasAttribute(ORIGINAL_ATTR)) return;
      const original = el.getAttribute(ORIGINAL_ATTR);
      if (original === '') {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', original);
      }
      el.removeAttribute(ORIGINAL_ATTR);
    } else {
      if (!el.hasAttribute(ORIGINAL_ATTR)) {
        el.setAttribute(ORIGINAL_ATTR, el.getAttribute('tabindex') ?? '');
      }
      el.setAttribute('tabindex', '-1');
    }
  });
};

export const FocusGuard = (watchKey = 'open') => ({
  'x-init'() {
    applyTabindex(this.$el, !!this[watchKey]);

    this.$watch(watchKey, (val) => applyTabindex(this.$el, !!val));
  },
});
